module.exports = __webpack_public_path__ + "static/img/logo-alt.69d65da5.png";